<template>
  <div name="stdapplinf-detail-pg15">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['10'] }}</label>
          <textarea class="form-control"
                    :value="data.reason"
                    readonly />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['20'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(data.dtewkst) }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgcivil === 'N' ? true : false" disabled>
                {{ labels['240'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgcivil === 'Y' ? true : false" disabled>
                {{ labels['250'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['40'] }}</label>
          <div class="form-control readonly-field-color">{{ data.lastpost }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['50'] }}</label>
          <div class="form-control readonly-field-color">{{ data.departmn }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['60'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgmilit === 'N' ? true : false" disabled>
                {{ labels['240'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgmilit === 'Y' ? true : false" disabled>
                {{ labels['250'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['70'] }}</label>
          <div class="form-control readonly-field-color">{{ data.desexcem }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['80'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgordan === 'N' ? true : false" disabled>
                {{ labels['240'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgordan === 'Y' ? true : false" disabled>
                {{ labels['250'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['110'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgcase === 'N' ? true : false" disabled>
                {{ labels['260'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgcase === 'Y' ? true : false" disabled>
                {{ labels['270'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['120'] }}</label>
          <div class="form-control readonly-field-color">{{ data.desdisea }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['130'] }}</label>
          <div class="form-control readonly-field-color">{{ data.dessymp }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['140'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgill === 'N' ? true : false" disabled>
                {{ labels['240'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgill === 'Y' ? true : false" disabled>
                {{ labels['250'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['150'] }}</label>
          <div class="form-control readonly-field-color">{{ data.desill }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['160'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgarres === 'N' ? true : false" disabled>
                {{ labels['240'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgarres === 'Y' ? true : false" disabled>
                {{ labels['250'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['170'] }}</label>
          <div class="form-control readonly-field-color">{{ data.desarres }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['180'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgknow === 'N' ? true : false" disabled>
                {{ labels['260'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgknow === 'Y' ? true : false" disabled>
                {{ labels['270'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['190'] }}</label>
          <div class="form-control readonly-field-color">{{ data.name }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['200'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgappl === 'N' ? true : false" disabled>
                {{ labels['240'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgappl === 'Y' ? true : false" disabled>
                {{ labels['250'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['210'] }}</label>
          <div class="form-control readonly-field-color">{{ data.lastpos2 }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['220'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgprov === 'N' ? true : false" disabled>
                {{ labels['280'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgprov === 'Y' ? true : false" disabled>
                {{ labels['290'] }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label>  </label>
          <div class="form-control readonly-field-color">{{ data.desnote }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['230'] }}</label>
          <textarea class="form-control"
                    :value="data.hobby"
                    readonly />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg15',
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg15.vue?0172f495